import React from 'react';

import classes from './AddonsWrapper.scss';

const addonsWrapper = (props) => {
    return (
        <div className={`${classes.Wrapper} u-backgroundColorWhite u-boxShadowThin u-borderRadius6`}>
            {props.children}
        </div>
    );
}

export default addonsWrapper;


// WEBPACK FOOTER //
// ./src/components/UI/Wrappers/AddonsWrapper/AddonsWrapper.js